export { default } from '@shikijs/langs/git-rebase'
